export default __webpack_public_path__ + "images/389ece7b7e2dc7ff8d28524bad30d52c-dsrp_desktop.webp";